export const OPERATOR_NAMES = {
  MalaysiaUmobileSLA: 'MALAYSIA-UMOBILE-SLA',
  MarocTelecom: 'MOROCCO-MAROCTELECOM',
  KuwaitZainIdex: 'KUWAIT-ZAIN-IDEX',
  BahrainZainSLA: 'BAHRAIN-ZAIN-SLA',
  TunisiaOrange: 'TUNISIA-ORANGE',
  MarocOrange: 'MOROCCO-ORANGE',
  LibyaLibyana: 'LIBYA-LIBYANA',
  IraqAsiaCell: 'IRAQ-ASIACELL',
  LibyaMadar: 'LIBYA-MADAR',
  MarocInwi: 'MOROCCO-INWI',
  KSA_Virgin: 'KSA-VIRGIN',
  KSA_MOBILY: 'KSA-MOBILY',
  IraqKorek: 'IRAQ-KOREK',
  DuEvina: 'UAE-DU-EVINA',
  KuwaitSTC: 'KUWAIT-STC',
  IraqZain: 'IRAQ-ZAIN',
  IraqFastLink: 'IRAQ-FASTLINK',
  Virgin: 'Virgin',
  STC: 'KSA-STC',
  KSA_REDBULL: 'KSA-REDBULL',
  PortugalVodafone: 'PORTUGAL-VODAFONE',
  PortugalMeo: 'PORTUGAL-MEO',
};
